import { isBrowser } from "~/utils/helpers";

export class DialogModalCoordinator {
  static shared = new DialogModalCoordinator();

  instances = new Set<string>();

  private _isShowing = false;

  private get isShowing() {
    return this._isShowing;
  }

  private set isShowing(isShowing) {
    const didChange = isShowing !== this._isShowing;

    this._isShowing = isShowing;

    if (!didChange) return;
  }

  lockScrolling(shouldLock: boolean) {
    const node = document.querySelector("body") as HTMLBodyElement;

    if (shouldLock) {
      node.style.overflow = "hidden";
    } else {
      node.style.removeProperty("overflow");
    }
  }

  afterUpdate() {
    this.isShowing = this.instances.size > 0;

    if (isBrowser()) {
      this.lockScrolling(this.isShowing);
    }
  }

  add(id: string) {
    this.instances.add(id);
    this.afterUpdate();
  }

  remove(id: string) {
    this.instances.delete(id);
    this.afterUpdate();
  }
}
